






















































import { computed, defineComponent, ref } from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import { useFormat } from '@ideavivat/vivat-2';

import useAuth from '@/useAuth';

import getOverallDailyReport from '@/gql/dashboard/getOverallDailyReport.gql';

import DeliveryHeatMap from '@/components/Map/DeliveryHeatMap.vue';

const Total = defineComponent({
  components: {
    DeliveryHeatMap,
  },
  setup() {
    const { me } = useAuth();
    const NOW = useFormat.date().computerShortDate();

    function displayDate(date: string) {
      return useFormat.date(date).displayFullThaiDate();
    }
    // const filterDateRange = reactive({
    //   from: NOW,
    //   to: NOW,
    // });

    const { result: getOverallDailyReportResult } = useQuery(getOverallDailyReport, computed(() => ({
      // date: NOW,
      filterHubId: me.hubId,
    })), () => ({ fetchPolicy: 'network-only' }));
    const overallDailyReport = useResult(getOverallDailyReportResult, {
      newDeliveries: 0.0,
      todayCount: 0,
      totalWeight: 0.0,
      dailyCarry: 0.0,
      deliveryTime: 0.0,
      unfinishDelivery: 0,
      unfinishWeight: 0.0,
    }, (data: any) => data.overallDailyReport);

    return {
      NOW,
      me,

      overallDailyReport,
      // filterDateRange,
      displayDate,
    };
  },
});

export default Total;
